<!--
 * @Author: wzh
 * @LastEditTime: 2023-01-04 09:29:15
 * @Description: 滑块验证
-->
<template>
	<div class="verifyModal">
		<div class="verifyMain">
			<div class="title">{{ $t("login.verify.tips") }} <a-icon type="close" @click="handleClose" /></div>
			<div class="verifyBox">
				<slide-verify
					:l="42"
					:r="10"
					:w="320"
					:h="168"
					:imgs="imgs"
					@success="handleSuccess"
					@fail="handleFail"
					@refresh="handleRefresh"
					@fulfilled="handleFulfilled"
					slider-text=""
				/>
				<div class="verifyResult" v-if="verifySuccess || verifyFail">
					<div class="success" v-if="verifySuccess">
						<a-icon type="check-circle" theme="filled" />
						<div>{{ $t("login.verify.success") }}</div>
					</div>
					<div class="fail" v-if="verifyFail">
						<a-icon type="close-circle" theme="filled" />
						<div>{{ $t("login.verify.error") }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// 滑块背景图
import slideImg from "@/assets/images/slide/img.jpg";
import slideImg1 from "@/assets/images/slide/img1.jpg";
import slideImg2 from "@/assets/images/slide/img2.jpg";
import slideImg3 from "@/assets/images/slide/img3.jpg";
import slideImg4 from "@/assets/images/slide/img4.jpg";
import slideImg5 from "@/assets/images/slide/img5.jpg";

export default {
	name: "SelfVerify",
	data() {
		return {
			imgs: [slideImg, slideImg1, slideImg2, slideImg3, slideImg4, slideImg5], // 滑块背景图
			verifyFail: false, // 拼图失败
			verifySuccess: false, // 拼图成功
		};
	},
	created() {},
	methods: {
		// 验证成功
		handleSuccess() {
			setTimeout(() => {
				this.$emit("success");
			}, 500);
		},
		// 验证失败
		handleFail() {
			this.verifyFail = true;
		},
		// 刷新
		handleRefresh() {},
		// 刷新成功
		handleFulfilled() {
			this.verifySuccess = false;
			this.verifyFail = false;
		},
		// 关闭
		handleClose() {
			this.$emit("close");
		},
	},
};
</script>

<style lang="scss" scoped>
.verifyModal::v-deep {
	position: fixed;
	width: 100vw;
	height: 100vh;
	top: 0;
	left: 0;
	background-color: rgba(0, 0, 0, 0.8);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 999;
	.verifyMain {
		padding: 0 20px 10px;
		background-color: #fff;
		border-radius: 10px;
		position: relative;
		.title {
			height: 64px;
			line-height: 64px;
			font-size: 16px;
			color: #000;
			position: relative;
			.anticon {
				position: absolute;
				font-size: 16px;
				top: 24px;
				right: 0;
			}
		}
		.verifyResult {
			position: absolute;
			width: 320px;
			height: 168px;
			top: 64px;
			left: 20px;
			background-color: rgba(255, 255, 255, 0.7);
			display: flex;
			align-items: center;
			justify-content: center;
			& > div {
				text-align: center;
				font-weight: 500;
				&.success {
					color: #2cd002;
				}
				&.fail {
					color: #f5222d;
				}
				.anticon {
					font-size: 44px;
					margin-bottom: 10px;
				}
			}
		}

		// 滑块样式
		.slide-verify {
			.slide-verify-refresh-icon {
				background: url("~@/assets/images/slide/slide-refresh.png") no-repeat center center / 18px;
				z-index: 9;
			}
			.slide-verify-slider {
				margin: 20px 0 25px;
				height: 14px;
				border-radius: 7px;
				border: none;
				background-color: #e4e4e4;

				.slide-verify-slider-mask {
					border: none !important;
					height: 14px;
					background: #1979ff !important;
					border-radius: 10px 0 0 10px;
				}
				.slide-verify-slider-mask-item {
					width: 56px;
					height: 28px;
					background: #1979ff !important;
					box-shadow: 0px 0px 9px 0px rgba(25, 121, 255, 0.74) !important;
					border-radius: 19px;
					border: none !important;
					top: -7px;
					display: flex;
					align-items: center;
					justify-content: center;
					transform: translate(-2px);
					&::before,
					&::after {
						display: inline-block;
						content: "";
						width: 2px;
						height: 12px;
						background: #fff;
						border-radius: 2px;
					}
					.slide-verify-slider-mask-item-icon {
						width: 2px;
						height: 12px;
						background: #fff;
						position: static;
						border-radius: 2px;
						display: inline-block;
						margin: 0 10px;
					}
				}
			}
		}
	}
}
</style>
